import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoDocumentsFound = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);
  const isDesktop = useIsDesktop();

  const redirects = [
    {
      text: generalDictionary.newRequestText,
      href: generalDictionary.newRequestHref,
    },
    {
      text: generalDictionary.personalTeamText,
      href: generalDictionary.personalTeamHref,
    },
  ];

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      redirects={redirects}
      headerComponent={
        <Stack gap='16px' alignItems={'center'} padding={'20px'}>
          <Typography
            variant='h2'
            color='text.secondary'
            alignSelf={isDesktop ? 'center' : 'flex-start'}
          >
            {dictionary.title}
          </Typography>
          <Stack
            justifyContent={'center'}
            marginBottom={isDesktop ? '20px' : undefined}
            flexWrap={'wrap'}
            textAlign={isDesktop ? 'center' : undefined}
          >
            <Typography
              variant={isDesktop ? 'body2' : 'body1'}
              color='text.secondary'
              marginRight={'5px'}
            >
              {dictionary.noDocuments}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {dictionary.subNoDocuments}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
